import React from 'react';
import { Link } from 'react-router-dom';
import { UtensilsCrossed, ShoppingBag, HardHat, Scissors, ArrowRight } from 'lucide-react';
import './IndustryPicks.css';

/* Clickable industry cards between the partners strip and the owners section.
   Each links to that industry's tailored landing page (/industries/<slug>). */
const PICKS = [
  {
    icon: UtensilsCrossed,
    label: 'Restaurants',
    blurb: 'Direct orders, synced reservations, an AI host',
    to: '/industries/restaurants'
  },
  {
    icon: ShoppingBag,
    label: 'Ecommerce',
    blurb: 'Your own store, no marketplace fees',
    to: '/industries/online-stores'
  },
  {
    icon: HardHat,
    label: 'Contractors',
    blurb: 'Every call answered, every job booked',
    to: '/industries/contractors'
  },
  {
    icon: Scissors,
    label: 'Salons & Spas',
    blurb: 'Full chairs, fewer no-shows, 5-star reviews',
    to: '/industries/salons-spas'
  }
];

const IndustryPicks = () => (
  <section className="industry-picks" aria-label="Browse by industry">
    <div className="industry-picks-inner">
      <p className="industry-picks-title">Built for your business</p>
      <div className="industry-picks-grid">
        {PICKS.map(({ icon: Icon, label, blurb, to }) => (
          <Link key={to} to={to} className="industry-pick-card">
            <span className="industry-pick-icon">
              <Icon size={20} strokeWidth={2.1} aria-hidden="true" />
            </span>
            <span className="industry-pick-text">
              <strong>{label}</strong>
              <small>{blurb}</small>
            </span>
            <ArrowRight size={16} strokeWidth={2.4} className="industry-pick-arrow" aria-hidden="true" />
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default IndustryPicks;
